import React, { useContext, useEffect, useState } from "react";
import myaxios from "../myaxios";
const mainContext = React.createContext();
export const MainStore = (props) => {
  const [txtmarquee, setTxtmarquee] = useState("");
  const [name, setName] = useState(
    `<h2  style="color: white"><strong>ЦЭРГИЙН ГАВЪЯАНЫ ОДОНТ ХИЛИЙН 0151 ДҮГЭЭР АНГИ<br>ЗАРЛАЛ, МЭДЭЭЛЛИЙН САМБАР</strong></h2>`
  );
  const [purpose, setPurpose] = useState(
    `<h3><span style="color:white;"><strong>Хил хамгаалах байгууллагын 2021 онд дэвшүүлсэн зорилт:</strong></span><br><span style="color:hsl(0,0%,100%);"><strong>&nbsp; &nbsp; &nbsp; - Хилчдийн хөгжлийн орчинг сайжруулж, хил хамгаалалтын үр дүнг дээшлүүлнэ.</strong></span></h3>`
  );
  const [logo1, setLogo1] = useState(
    "iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII"
  );
  const [logo2, setLogo2] = useState(
    "iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII"
  );

  const [col1headdata, setCol1headdata] = useState("");
  const [col2headdata, setCol2headdata] = useState("");
  const [col3headdata, setCol3headdata] = useState("");
  const [col1fooddata, setCol1fooddata] = useState("");
  const [col2fooddata, setCol2fooddata] = useState("");
  const [col3fooddata, setCol3fooddata] = useState("");
  const [col1imagedata, setCol1imagedata] = useState([]);
  const [col2imagedata, setCol2imagedata] = useState([]);
  const [col3imagedata, setCol3imagedata] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const interval = setInterval(() => {
      getTxtmarquee();
      getHeader();
      getLogo1();
      getLogo2();
      getPurpose();
      getcol1headdata();
      getcol2headdata();
      getcol3headdata();
      getcol1fooddata();
      getcol2fooddata();
      getcol3fooddata();
      getCol1ImageData();
      getCol2ImageData();
      getCol3ImageData();
    }, 60000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    getTxtmarquee();
    getHeader();
    getLogo1();
    getLogo2();
    getPurpose();
    getcol1headdata();
    getcol2headdata();
    getcol3headdata();
    getcol1fooddata();
    getcol2fooddata();
    getcol3fooddata();

    getCol1ImageData();
    getCol2ImageData();
    getCol3ImageData();
  }, []);

  const getHeader = () => {
    setLoading(true);
    myaxios
      .get("/?requestcode=8100")
      .then((response) => {
        response.data.result != "nodata" && setName(response.data.result);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  const getTxtmarquee = () => {
    setLoading(true);
    myaxios
      .get("/?requestcode=8300")
      .then((response) => {
        response.data.result != "nodata" && setTxtmarquee(response.data.result);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  const getLogo1 = () => {
    setLoading(true);
    myaxios
      .get("/?requestcode=8102")
      .then((response) => {
        response.data.result != "nodata" && setLogo1(response.data.result);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  const getLogo2 = () => {
    setLoading(true);
    myaxios
      .get("/?requestcode=8103")
      .then((response) => {
        response.data.result != "nodata" && setLogo2(response.data.result);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const getPurpose = () => {
    setLoading(true);
    myaxios
      .get("/?requestcode=8200")
      .then((response) => {
        response.data.result != "nodata" && setPurpose(response.data.result);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  const getcol1headdata = () => {
    setLoading(true);
    myaxios
      .get("/?requestcode=1001")
      .then((response) => {
        response.data.result != "nodata" &&
          setCol1headdata(response.data.result);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  const getcol2headdata = () => {
    setLoading(true);
    myaxios
      .get("/?requestcode=2001")
      .then((response) => {
        response.data.result != "nodata" &&
          setCol2headdata(response.data.result);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  const getcol3headdata = () => {
    setLoading(true);
    myaxios
      .get("/?requestcode=3001")
      .then((response) => {
        response.data.result != "nodata" &&
          setCol3headdata(response.data.result);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const getcol1fooddata = () => {
    setLoading(true);
    myaxios
      .get("/?requestcode=1003")
      .then((response) => {
        response.data.result != "nodata" &&
          setCol1fooddata(response.data.result);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  const getcol2fooddata = () => {
    setLoading(true);
    myaxios
      .get("/?requestcode=2003")
      .then((response) => {
        response.data.result != "nodata" &&
          setCol2fooddata(response.data.result);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  const getcol3fooddata = () => {
    setLoading(true);
    myaxios
      .get("/?requestcode=3003")
      .then((response) => {
        response.data.result != "nodata" &&
          setCol3fooddata(response.data.result);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  const getCol1ImageData = () => {
    setLoading(true);
    myaxios
      .get("/?requestcode=1002")
      .then((response) => {
        response.data.result != "nodata" &&
          setCol1imagedata(response.data.result);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const getCol2ImageData = () => {
    setLoading(true);
    myaxios
      .get("/?requestcode=2002")
      .then((response) => {
        response.data.result != "nodata" &&
          setCol2imagedata(response.data.result);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const getCol3ImageData = () => {
    setLoading(true);
    myaxios
      .get("/?requestcode=3002")
      .then((response) => {
        response.data.result != "nodata" &&
          setCol3imagedata(response.data.result);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  return (
    <mainContext.Provider
      value={{
        txtmarquee,
        setTxtmarquee,
        getTxtmarquee,
        name,
        purpose,
        logo1,
        logo2,
        col1fooddata,
        col2fooddata,
        col3fooddata,
        col1headdata,
        col2headdata,
        col3headdata,
        loading,
        col1imagedata,
        col2imagedata,
        col3imagedata,
      }}
    >
      {props.children}
    </mainContext.Provider>
  );
};
export default mainContext;
